import React from 'react';
import { Box, Grid, Card, CardContent, Typography, Chip, Avatar, Button, Divider } from '@mui/material';
import { brandColors } from '../../theme';

const articles = Array.from({ length: 8 }).map((_, i) => ({
  id: i + 1,
  title: `Neuigkeit ${i + 1}: Trends im lokalen Marketing`,
  excerpt: 'Kurzüberblick darüber, wie Sie Ihre regionale Reichweite mit smarten Werbemitteln steigern können.',
  category: i % 3 === 0 ? 'Guides' : i % 3 === 1 ? 'Case Study' : 'News',
  author: 'R2B Team',
  date: '2025-09-22',
  cover: `https://picsum.photos/seed/r2b-${i}/800/480`,
}));

const LandingPage: React.FC = () => {
  return (
    <Box>
      <Box
        sx={{
          mb: 4,
          p: { xs: 3, md: 6 },
          borderRadius: 'var(--radius)',
          border: '1px solid var(--line)',
          position: 'relative',
          overflow: 'hidden',
          background: `linear-gradient(135deg, ${brandColors.electricTeal}15 0%, ${brandColors.midnightSteel}10 100%)`,
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontWeight: 900,
            mb: 1,
            color: 'var(--ink)',
            fontSize: { xs: '2rem', md: '3rem' },
            letterSpacing: '-0.02em'
          }}
        >
          Werbemittel News & Inspiration
        </Typography>
        <Typography variant="body1" sx={{ color: 'var(--muted)', maxWidth: 780, mb: 2 }}>
          Aktuelle Trends, Praxisbeispiele und Tipps rund um Print, Außenwerbung und mehr – alles an einem Ort.
        </Typography>
        <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
          <Button variant="contained" sx={{ bgcolor: brandColors.electricTeal }}>Neueste Beiträge</Button>
          <Button variant="outlined">Abonnieren</Button>
        </Box>
      </Box>

      <Grid container spacing={3}>
        {articles.map((post, idx) => (
          <Grid
            key={post.id}
            size={{ xs: 12, sm: 6, md: 4 }}
          >
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', border: '1px solid var(--line)', backgroundColor: 'var(--card)', borderRadius: 'var(--radius)' }}>
              <Box component="img" src={post.cover} alt={post.title} sx={{ width: '100%', height: 180, objectFit: 'cover', borderTopLeftRadius: 'var(--radius)', borderTopRightRadius: 'var(--radius)' }} />
              <CardContent sx={{ flex: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                  <Chip label={post.category} size="small" sx={{ bgcolor: `${brandColors.electricTeal}20`, color: brandColors.electricTeal, fontWeight: 600 }} />
                  <Typography variant="caption" color="text.secondary">{post.date}</Typography>
                </Box>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1, color: 'var(--ink)' }}>
                  {post.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  {post.excerpt}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Avatar sx={{ bgcolor: brandColors.electricTeal, width: 28, height: 28 }} />
                  <Typography variant="caption" color="text.secondary">{post.author}</Typography>
                </Box>
              </CardContent>
              <Box sx={{ p: 2, pt: 0 }}>
                <Button variant="text" sx={{ color: brandColors.electricTeal, fontWeight: 700, textTransform: 'none' }}>Weiterlesen →</Button>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Artikel list moved to dedicated page */}
    </Box>
  );
};

export default LandingPage;


